module.exports = __webpack_public_path__ + "img/pickme.412f7614.png";